import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/projects/michelin-hp/node_modules/@babel/runtime/helpers/asyncToGenerator";
import { axiosInstance } from 'boot/axios.js';
export function width(_x) {
  return _width.apply(this, arguments);
}

function _width() {
  _width = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ctx) {
    var queryParams,
        response,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryParams = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _context.prev = 1;
            _context.next = 4;
            return axiosInstance({
              url: 'width-measures',
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context.sent;
            ctx.commit('width', response.data.items);
            return _context.abrupt("return", response);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            throw _context.t0;

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 9]]);
  }));
  return _width.apply(this, arguments);
}

export function height(_x2) {
  return _height.apply(this, arguments);
}

function _height() {
  _height = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ctx) {
    var queryParams,
        response,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            queryParams = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _context2.prev = 1;
            _context2.next = 4;
            return axiosInstance({
              url: 'height-measures',
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context2.sent;
            ctx.commit('height', response.data.items);
            return _context2.abrupt("return", response);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            throw _context2.t0;

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 9]]);
  }));
  return _height.apply(this, arguments);
}

export function rim(_x3) {
  return _rim.apply(this, arguments);
}

function _rim() {
  _rim = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(ctx) {
    var queryParams,
        response,
        _args3 = arguments;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            queryParams = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
            _context3.prev = 1;
            _context3.next = 4;
            return axiosInstance({
              url: 'rim-measures',
              params: queryParams,
              method: 'GET'
            });

          case 4:
            response = _context3.sent;
            ctx.commit('rim', response.data.items);
            return _context3.abrupt("return", response);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](1);
            throw _context3.t0;

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 9]]);
  }));
  return _rim.apply(this, arguments);
}

export function setWidth(ctx, data) {
  ctx.commit('setWidth', data);
}
export function setHeight(ctx, data) {
  ctx.commit('setWidth', data);
}
export function setRim(ctx, data) {
  ctx.commit('setWidth', data);
}